import { render, staticRenderFns } from "./MailingView.vue?vue&type=template&id=ed12a506&"
import script from "./MailingView.vue?vue&type=script&lang=js&"
export * from "./MailingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports